import { createSlice } from '@reduxjs/toolkit';
import { getSourceListThunk } from './Source.thunk';

export const sourceSlice = createSlice({
  name: 'source',
  initialState: {
    list: {
      items: [],
      loading: true,
      pagination: {},
    },
  },
  reducers: {
    resetSourceListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
  },
  extraReducers: builder => {
    // Start SourceControl list
    builder.addCase(getSourceListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getSourceListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = _pagination
        ? {
            currentPage: _pagination.current_page,
            lastPage: _pagination.last_page,
            total: _pagination.total,
          }
        : {};
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getSourceListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End SourceControl list
  },
});

export const getSourceList = (state: any) => state.source.list;

export default sourceSlice.reducer;
